import axios from 'axios'
import { SERVER } from '../config'
import { showAlert } from 'services/alerts.service'

// Axios instance with preconfigured baseURL
const instance = axios.create({
  baseURL: `${SERVER.url}/${SERVER.apiPath}`
})

const makeRequest = async ({
  method,
  url,
  headers = {},
  data = null,
  alertResult = false,
  responseType = undefined,
  signal = undefined,
  onUploadProgress = undefined
}) => {
  const response = await instance.request({
    method,
    url,
    headers,
    data,
    ...(responseType ? { responseType } : {}),
    ...(signal ? { signal } : {}),
    ...(onUploadProgress ? { onUploadProgress } : {})
  })

  if (alertResult) {
    showAlert({
      text: response?.data?.message || 'Request succeeded',
      icon: 'success'
    })
  }

  if (process.env.NODE_ENV === 'development') {
    console.info(`Request ${method} ${url} succeeded`, response)
  }

  return response
}

export {
  makeRequest
}
